import { atom } from 'recoil'

export const visitorState = atom({
    key: 'visitor',
    default: {id: 0, name: 'Visitor', email: ''}, 
  });